/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { useEffect, useState } from "react";
import Checkbox from "../../../components/common/CheckBox";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import { getFileExtension } from "../../../utilities/helper";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";
import {
  IconCloudUpload,
  IconPhoto,
  IconTrash,
  IconUser,
} from "@tabler/icons-react";
import { useSelector } from "react-redux";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../../apis/locationApis";
import PickupAddressPicker from "../../ManifestManagement/_components/PickupAddressPicker";
import ToggleButton from "../../../components/ToggleButton";
import { useLanguage } from "../../../context/LanguageContext";

type FormValues = {
  name: string;
  mobileNo: string;
  email: string;
  contactType: string;
  vatNumber: string;
  nationalId: string;
  nationalCopy: string;
  crNumber: string;
  warehouse: string;
  contactPerson: string;
  district: string;
  city: string;
  paymentTerm: string;
  access: string;
  clientType: string;
  contractDate: Date;
  location: string;
  vatDocument: File | undefined;
  crCopy: File | undefined;
  companyLogo: File | undefined;
  contractDocument: File | undefined;
  shortAddress?: string;
  password?: string;

  // Merchant Address Fields
  merchantCountryId?: string;
  merchantCityId?: string;
  merchantDistrictId?: string;
  merchantShortAddress?: string;
  merchantFullAddress?: string;
  merchantLatitude?: string;
  merchantLongitude?: string;
  isNippco?: boolean;
  radius?: string;
};

type Props = {
  register: UseFormRegister<any>;
  errors: FieldErrors<FormValues>;
  clearErrors?: any;
  setValue?: any;
  getIds?: any;
  watch?: any;
  control?: any;
  setSelectedDocument?: any;
  merchantData?: any;
};

export const SystemTypes = [
  { id: "1", value: "phone", text: "Phone" },
  { id: "2", value: "email", text: "Email" },
  { id: "3", value: "whatsapp", text: "WhatsApp" },
];

export const PaymentTerm = [
  { id: "1", value: "DAILY", text: "Daily" },
  { id: "2", value: "WEEKLY", text: "Weekly" },
  { id: "3", value: "MONTHLY", text: "Monthly" },
];

export const clientType = [
  { id: "1", value: "B2B", text: "B2B" },
  { id: "2", value: "B2C", text: "B2C" },
  { id: "3", value: "Both", text: "Both" },
];

export const Access = [
  { id: "1", value: "FM", text: "FM" },
  { id: "2", value: "LM", text: "LM" },
  { id: "3", value: "BOTH", text: "Both" },
];

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => {
  const { t } = useLanguage();
  return (
    <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
      <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
        <Icon size={16} className="text-[#212121]" stroke={1.5} />
      </div>
      <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
        {t(title)}
      </p>
    </div>
  );
};

const AddMerchantModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  control,
  getIds,
  watch,
  setSelectedDocument,
  merchantData,
}: Props) => {
  const { t } = useLanguage();
  const [selectedData, setSelectedData] = useState<any>({
    warehouse: "",
    country: "",
    city: "",
    district: "",
  });

  const [merchantLocation, setMerchantLocation] = useState<any>({
    country: undefined,
    city: undefined,
    district: undefined,
  });

  const { data: countries = [] } = useFetchCountriesAllData();
  const { data: cities = [], refetch: fetchCities } =
    useFetchCountryCitiesAllData(merchantLocation?.country?.id);

  const {
    data: warehouses,
    isPending: listPending,
    refetch: warehouseRefetch,
  } = useWarehouseListData();

  useEffect(() => {
    if (merchantLocation?.country?.id) {
      fetchCities();
    }
  }, [merchantLocation?.country?.id]);

  useEffect(() => {
    if (selectedData) {
      getIds(selectedData);
    }
  }, [selectedData]);

  useEffect(() => {
    if (merchantData) {
      setValue("name", merchantData?.name);
      setValue("contactPerson", merchantData?.staffName);
      setValue("mobileNo", merchantData?.mobileNo);
      setValue("email", merchantData?.email);
      setValue("contactType", merchantData?.contactType);
      setValue("companyLogo", merchantData?.companyLogo);
      setValue("country", merchantData?.countryId);
      setValue(
        "warehouse",
        merchantData?.warehouse || merchantData?.warehouseId,
      );
      setValue("city", merchantData?.city);
      setValue("district", merchantData?.district);
      setValue("paymentTerm", merchantData?.paymentTerm);
      setValue("access", merchantData?.access);
      setValue("clientType", merchantData?.clientType);
      setValue("contractDate", merchantData?.contractDate?.split("T")?.[0]);
      setValue("contractDocument", merchantData?.contractDocument);
      setValue("vatNumber", merchantData?.vatNumber);
      setValue("vatDocument", merchantData?.vatDocument);
      setValue("crNumber", merchantData?.crNumber);
      setValue("crCopy", merchantData?.crCopy);
      setValue("location", merchantData?.location);
      setValue("nationalId", merchantData?.nationalId);
      setValue("nationalCopy", merchantData?.nationalCopy);
      setValue("shortAddress", merchantData?.shortAddress);

      // Merchant Address fields
      const hasMerchantAddr = !!merchantData?.merchantCountryId;
      setValue(
        "merchantCountryId",
        hasMerchantAddr
          ? merchantData?.merchantCountryId
          : merchantData?.countryId,
      );
      setValue(
        "merchantCityId",
        hasMerchantAddr ? merchantData?.merchantCityId : merchantData?.cityId,
      );
      setValue(
        "merchantPinCode",
        hasMerchantAddr ? merchantData?.merchantPinCode : merchantData?.pinCode,
      );
      setValue(
        "merchantDistrictId",
        hasMerchantAddr
          ? merchantData?.merchantDistrictId
          : merchantData?.districtId,
      );
      setValue(
        "merchantShortAddress",
        hasMerchantAddr
          ? merchantData?.merchantShortAddress
          : merchantData?.shortAddress,
      );
      setValue(
        "merchantFullAddress",
        hasMerchantAddr
          ? merchantData?.merchantFullAddress
          : merchantData?.location,
      );
      setValue(
        "merchantLatitude",
        hasMerchantAddr
          ? (merchantData?.merchantLatitude ?? "")
          : (merchantData?.latitude ?? ""),
      );
      setValue(
        "merchantLongitude",
        hasMerchantAddr
          ? (merchantData?.merchantLongitude ?? "")
          : (merchantData?.longitude ?? ""),
      );
      setValue("isNippco", merchantData?.isNippco);
      setValue("radius", merchantData?.radius);

      setSelectedData({
        warehouse: merchantData?.warehouseId,
        country: merchantData?.countryId,
        city: merchantData?.cityId,
        district: merchantData?.districtId,
      });

      setMerchantLocation({
        country: hasMerchantAddr
          ? merchantData?.merchantCountryId
            ? {
                id: merchantData.merchantCountryId,
                name: merchantData.merchantCountry ?? "",
              }
            : undefined
          : merchantData?.countryId
            ? { id: merchantData.countryId, name: merchantData.country ?? "" }
            : undefined,
        city: hasMerchantAddr
          ? merchantData?.merchantCityId
            ? {
                id: merchantData.merchantCityId,
                name: merchantData.merchantCity ?? "",
              }
            : undefined
          : merchantData?.cityId
            ? { id: merchantData.cityId, name: merchantData.city ?? "" }
            : undefined,
        district: hasMerchantAddr
          ? merchantData?.merchantDistrictId
            ? {
                id: merchantData.merchantDistrictId,
                name: merchantData.merchantDistrict ?? "",
              }
            : undefined
          : merchantData?.districtId
            ? { id: merchantData.districtId, name: merchantData.district ?? "" }
            : undefined,
      });
    }
  }, [merchantData, setValue]);

  const isNippco = watch("isNippco");

  // Only admin can edit the passsword of merchant
  const profile = useSelector((state: any) => state.auth.profile);
  const isClient = profile?.type === "client";
  return (
    <div className="w-full space-y-4">
      <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4 p-4 scrollbar-clean">
        {/* Merchant Information */}

        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <div className="flex items-center justify-between">
            <SectionHeader icon={IconUser} title="Merchant Information" />
            <div className="flex items-center gap-2 bg-[#FBD037]/10 px-3 py-1 rounded-full border border-[#FBD037]/20">
              <span className="text-xs font-semibold text-[#212121]">
                {t("Nippco")}
              </span>
              <Controller
                name="isNippco"
                control={control}
                render={({ field }) => (
                  <ToggleButton
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                )}
              />
            </div>
          </div>
          <Controller
            control={control}
            name="companyLogo"
            rules={{
              validate: (file: File | string | undefined) => {
                if (!file || typeof file === "string") return true;
                if (file.size > 1 * 1024 * 1024)
                  return t("File size must be 1 MB or less");
                const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                const fileObj = file instanceof File ? file : null;
                if (fileObj && !allowedTypes.includes(fileObj.type)) {
                  if (
                    !["jpeg", "png", "jpg"].includes(getFileExtension(fileObj))
                  )
                    return t("Only JPG, JPEG, or PNG allowed");
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => {
              const fileURL =
                field.value instanceof File
                  ? URL.createObjectURL(field.value)
                  : typeof field.value === "string" && field.value !== ""
                    ? field.value
                    : "/img/dummy-logo.png";

              return (
                <div className="flex items-center gap-5 p-3 bg-gray-50/50 rounded-xl border border-dashed border-gray-200">
                  <div className="relative group">
                    <img
                      src={fileURL}
                      alt="Staff Profile"
                      className="w-20 h-20 rounded-xl object-cover border-2 border-[#FBD037]/50 shadow-md transition-all group-hover:scale-105"
                    />
                    <div className="absolute -bottom-1 -right-1 bg-[#FBD037] rounded-full p-0.5">
                      <IconPhoto size={14} className="text-white" />
                    </div>
                  </div>

                  <div className="space-y-1.5 flex-1">
                    <div className="flex items-center gap-3">
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        className="hidden"
                        id="photo-upload"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              companyLogo: true,
                            }));
                            clearErrors("companyLogo");
                          }
                        }}
                      />
                      <label
                        htmlFor="photo-upload"
                        className="inline-flex items-center gap-2 text-[#212121] cursor-pointer border rounded-lg text-sm px-4 py-1.5 border-[#FBD037] bg-[#FBD037]/20 hover:bg-[#FBD037]/30 transition-all duration-200 font-medium"
                      >
                        <IconCloudUpload size={16} stroke={1.5} />
                        {t("Upload Logo")}
                      </label>

                      {field.value && (
                        <button
                          type="button"
                          className="inline-flex items-center gap-1 text-red-500 text-sm hover:underline transition"
                          onClick={() => {
                            field.onChange(undefined);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              companyLogo: false,
                            }));
                          }}
                        >
                          <IconTrash size={14} />
                          {t("Remove")}
                        </button>
                      )}
                    </div>

                    <p className="text-xs text-gray-400">
                      {t("Accepted formats: PNG, JPG (Max file size: 1 MB)")}
                    </p>

                    {fieldState.error && (
                      <p className="text-red-500 text-xs font-medium mt-1 flex items-center gap-1">
                        <span className="text-red-400">⚠</span>{" "}
                        {t(fieldState.error.message || "")}
                      </p>
                    )}
                  </div>
                </div>
              );
            }}
          />

          <div className="grid grid-cols-2 gap-4">
            <NewinputField
              name="name"
              type="text"
              title="Business Name"
              placeholder="Enter Full Name/ Business Name"
              register={register}
              error={errors?.name}
              validation={{
                required: "Name is required",
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 3)
                    return "Name must be at least 3 characters";
                  if (trimmed.length > 30)
                    return "Name must be at most 30 characters";
                  if (!value?.trim())
                    return "Name cannot be empty or only spaces";
                  return true;
                },
                pattern: {
                  value: /^(?=.*[A-Za-z\u0600-\u06FF])[A-Za-z\u0600-\u06FF0-9\s-]+$/,
                  message:
                    "Name must include at least one letter (not only numbers)",
                },
              }}
            />
            <NewinputField
              name="mobileNo"
              type="text"
              title="Mobile No"
              placeholder="Enter Mobile Number"
              register={register}
              error={errors?.mobileNo}
              validation={{
                required: "Mobile number is required",
                pattern: {
                  value: /^\d{9,10}$/,
                  message: "Mobile number must be 9 or 10 digits",
                },
                validate: (value: string) => {
                  if (/^0+$/.test(value)) {
                    return "Mobile number cannot be all zeros";
                  }
                  return true;
                },
              }}
              other={{
                maxLength: 10,
                inputMode: "numeric",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  let value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setValue("mobileNo", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              }}
            />

            <NewinputField
              name="email"
              type="text"
              title="Email"
              placeholder="Enter Email Address"
              register={register}
              error={errors?.email}
              validation={{
                required: "Email is required",
                setValueAs: (value: string) => value?.toLowerCase(),
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              }}
            />

            <NewinputField
              name="contactPerson"
              type="text"
              title="Contact Person"
              placeholder="Enter Contact Person Name"
              register={register}
              error={errors?.contactPerson}
              validation={{
                required: "Contact Person is required",
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 3)
                    return "Contact person must be at least 3 characters";
                  if (trimmed.length > 30)
                    return "Contact person must be at most 30 characters";
                  return true;
                },
              }}
            />
            {merchantData && isClient && (
              <NewinputField
                name="password"
                type="password"
                title="Password"
                placeholder="Leave blank to keep ..."
                register={register}
                error={errors?.password}
                validation={{
                  required: false, // ✅ optional on edit
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters",
                  },
                  validate: (value: string) => {
                    if (!value) return true;
                    if (!/[A-Z]/.test(value))
                      return "Must contain at least one uppercase letter";
                    if (!/[a-z]/.test(value))
                      return "Must contain at least one lowercase letter";
                    if (!/[0-9]/.test(value))
                      return "Must contain at least one number";
                    if (!/[!@#$%^&*(),.?/":{}|<>]/.test(value))
                      return "Must contain at least one special character";
                    return true;
                  },
                }}
              />
            )}

            <Checkbox
              className="col-span-2"
              name="contactType"
              label="Preferred Contact Method"
              otherName="flex items-center"
              valuesArr={[
                { value: "PHONE", text: "Phone" },
                { value: "EMAIL", text: "Email" },
                { value: "WHATSAPP", text: "Whatsapp" },
              ]}
              register={register}
              validation={{
                validate: (value: any) =>
                  value?.length > 0 ? true : "At least one option required",
              }}
              error={errors?.contactType}
            />
          </div>
        </div>
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title=" Merchant Office Address" />
          <PickupAddressPicker
            register={register}
            errors={errors}
            setValue={setValue}
            control={control}
            clearErrors={clearErrors}
            countries={countries}
            cities={cities}
            selectedCountry={merchantLocation.country}
            selectedCity={merchantLocation.city}
            selectedDistrict={merchantLocation.district}
            onCountryChange={(country) => {
              setMerchantLocation((prev: any) => ({
                ...prev,
                country,
                city: undefined,
                district: undefined,
              }));
            }}
            onCityChange={(city) => {
              setMerchantLocation((prev: any) => ({
                ...prev,
                city,
                district: undefined,
              }));
            }}
            onDistrictChange={(district) => {
              setMerchantLocation((prev: any) => ({ ...prev, district }));
            }}
            fieldPrefix="merchant"
            mode={merchantData ? "edit" : "add"}
          />
        </div>
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title="Business Details" />
          <div className="grid grid-cols-2 gap-4">
            <NewSelectInput
              name="warehouse"
              label="Warehouse"
              placeholder="Select"
              selectOptions={
                warehouses?.warehouses?.map((warehouse: any) => ({
                  id: warehouse?.id,
                  value: warehouse?.id,
                  text: warehouse?.name,
                })) || []
              }
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Warehouse is required" }}
              error={errors.warehouse}
              disabled={!warehouses || warehouses?.warehouses?.length === 0}
              value={watch("warehouse")}
              setValue={(val: string) => {
                const selectedW = warehouses?.warehouses?.find(
                  (e: any) => e?.id === val,
                );
                if (selectedW) {
                  setValue("warehouse", selectedW.id);
                  setValue("city", selectedW.cityName);
                  setValue("district", selectedW.districtName);
                  setValue("location", selectedW.location);
                  setValue("shortAddress", selectedW.shortAddress);

                  setSelectedData((prev: any) => ({
                    ...prev,
                    warehouse: selectedW.id,
                    country: selectedW.country,
                    city: selectedW.city,
                    district: selectedW.district,
                  }));
                }
                clearErrors(["city", "district", "location"]);
              }}
            />
            <NewSelectInput
              name="paymentTerm"
              label="Payment Terms"
              placeholder="Select"
              selectOptions={
                PaymentTerm?.map((payment: any) => ({
                  id: payment?.id,
                  value: payment?.value,
                  text: payment?.text,
                })) || []
              }
              register={register}
              validation={{ required: "Payment term is required" }}
              error={errors?.paymentTerm}
              disabled={!PaymentTerm || PaymentTerm.length === 0}
              clearErrors={clearErrors}
              value={watch("paymentTerm")}
              setValue={(val: any) => {
                setValue("paymentTerm", val);
              }}
            />
            <NewSelectInput
              name="access"
              label="Access"
              placeholder="Select"
              selectOptions={
                Access?.map((acc: any) => ({
                  id: acc?.id,
                  value: acc?.value,
                  text: acc?.text,
                })) || []
              }
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Access is required" }}
              error={errors?.access}
              disabled={!Access || Access.length === 0}
              value={watch("access")}
              setValue={(val: any) => {
                setValue("access", val);
              }}
            />
            <NewSelectInput
              name="clientType"
              label="Merchant Type"
              placeholder="Select"
              selectOptions={
                clientType?.map((type: any) => ({
                  id: type?.id,
                  value: type?.value,
                  text: type?.text,
                })) || []
              }
              register={register}
              validation={{ required: "Merchant type is required" }}
              error={errors?.clientType}
              disabled={!clientType || clientType.length === 0}
              clearErrors={clearErrors}
              value={watch("clientType")}
              setValue={(val: any) => {
                setValue("clientType", val);
              }}
            />
          </div>
        </div>

        {/* Legal & Tax Information */}
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title="Legal Information" />
          <div className="grid grid-cols-2 gap-4">
            <div className="grid grid-cols-[1fr_auto] gap-2 items-start">
              <NewinputField
                name="vatNumber"
                className="w-full"
                type="text"
                title="Tax/VAT Number"
                placeholder="Enter 15 Digit Tax/VAT Number"
                register={register}
                error={errors?.vatNumber}
                validation={{
                  required: "Vat Number is required",
                  pattern: {
                    value: /^\d{15}$/,
                    message: "Tax/VAT number must be exactly 15 digits",
                  },
                }}
                other={{
                  maxLength: 15,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 15);
                    setValue("vatNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />
              <Controller
                control={control}
                name="vatDocument"
                rules={{
                  validate: (file: File) => {
                    const vatNumber = watch("vatNumber")?.toString().trim();
                    if (vatNumber && !file) return "Please select a file";
                    if (file) {
                      if (file?.size > 1 * 1024 * 1024)
                        return "File size must be 1 MB or less";
                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, or PNG files are allowed";
                      }
                    }
                    return true;
                  },
                }}
                render={({ field, fieldState }) => {
                  const fileName =
                    field.value instanceof File
                      ? field.value.name
                      : typeof field.value === "string" && field.value
                        ? decodeURIComponent(field.value.split("/").pop() || "")
                        : "";

                  return (
                    <div className="flex flex-col gap-1">
                      <p className="text-sm text-transparent select-none">u</p>
                      <input
                        type="file"
                        id="vat-doc"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              vatDocument: true,
                            }));
                          }
                        }}
                      />
                      <label
                        htmlFor="vat-doc"
                        className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                      >
                        <IconCloudUpload stroke={1} size={20} />
                      </label>
                      {fieldState.error ? (
                        <p className="text-red-500 text-xs leading-tight">
                          {fieldState.error.message}
                        </p>
                      ) : fileName ? (
                        <p
                          className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                          title={fileName}
                        >
                          ✓ Uploaded File{" "}
                          {fileName.length > 12
                            ? `${fileName.slice(0, 12)}...`
                            : fileName}
                        </p>
                      ) : null}
                    </div>
                  );
                }}
              />
            </div>

            <div className="grid grid-cols-[1fr_auto] gap-2 items-start">
              <NewinputField
                name="crNumber"
                className="w-full"
                type="text"
                title="CR Number"
                placeholder="Enter 10 Digit CR Number"
                register={register}
                error={errors?.crNumber}
                validation={{
                  required: "CR number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "CR number must be exactly 10 digits",
                  },
                }}
                other={{
                  maxLength: 10,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setValue("crNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />
              <Controller
                control={control}
                name="crCopy"
                rules={{
                  required: "File is required",
                  validate: (file: File) => {
                    if (!file) return "Please select a file";
                    if (file?.size > 1 * 1024 * 1024)
                      return "File size must be 1 MB or less";
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                    ];
                    if (
                      file.type
                        ? !allowedTypes.includes(file.type)
                        : !["jpeg", "png", "jpg"].includes(
                            getFileExtension(file as any),
                          )
                    ) {
                      return "Only JPG, JPEG, or PNG allowed";
                    }
                    return true;
                  },
                }}
                render={({ field, fieldState }) => {
                  const fileName =
                    field.value instanceof File
                      ? field.value.name
                      : typeof field.value === "string" && field.value
                        ? decodeURIComponent(field.value.split("/").pop() || "")
                        : "";

                  return (
                    <div className="flex flex-col gap-1">
                      <p className="text-sm text-transparent select-none">u</p>
                      <input
                        type="file"
                        id="cr-doc"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              crCopy: true,
                            }));
                          }
                        }}
                      />
                      <label
                        htmlFor="cr-doc"
                        className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                      >
                        <IconCloudUpload stroke={1} size={20} />
                      </label>
                      {fieldState.error ? (
                        <p className="text-red-500 text-xs leading-tight">
                          {fieldState.error.message}
                        </p>
                      ) : fileName ? (
                        <p
                          className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                          title={fileName}
                        >
                          ✓ Uploaded File{" "}
                          {fileName.length > 12
                            ? `${fileName.slice(0, 12)}...`
                            : fileName}
                        </p>
                      ) : null}
                    </div>
                  );
                }}
              />
            </div>

            <div className="grid grid-cols-[1fr_auto] gap-2 items-start">
              <NewinputField
                name="nationalId"
                className="w-full"
                type="text"
                title="National ID"
                placeholder="Enter 10 Digit National ID"
                register={register}
                error={errors?.nationalId}
                validation={{
                  validate: (value: string) => {
                    if (!value) return true;
                    if (!/^\d{10}$/.test(value))
                      return "National ID must be exactly 10 digits";
                    return true;
                  },
                }}
                other={{
                  maxLength: 10,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setValue("nationalId", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />
              <Controller
                control={control}
                name="nationalCopy"
                rules={{
                  validate: (file: File) => {
                    const nationalId = watch("nationalId")?.toString().trim();
                    if (nationalId && !file) return "Please select a file";
                    if (file) {
                      if (file?.size > 1 * 1024 * 1024)
                        return "File size must be 1 MB or less";
                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, or PNG files are allowed";
                      }
                    }
                    return true;
                  },
                }}
                render={({ field, fieldState }) => {
                  const fileName =
                    field.value instanceof File
                      ? field.value.name
                      : typeof field.value === "string" && field.value
                        ? decodeURIComponent(field.value.split("/").pop() || "")
                        : "";

                  return (
                    <div className="flex flex-col gap-1">
                      <p className="text-sm text-transparent select-none">u</p>
                      <input
                        type="file"
                        id="nid-doc"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              nationalCopy: true,
                            }));
                          }
                        }}
                      />
                      <label
                        htmlFor="nid-doc"
                        className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                      >
                        <IconCloudUpload stroke={1} size={20} />
                      </label>
                      {fieldState.error ? (
                        <p className="text-red-500 text-xs leading-tight">
                          {fieldState.error.message}
                        </p>
                      ) : fileName ? (
                        <p
                          className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                          title={fileName}
                        >
                          ✓ Uploaded File{" "}
                          {fileName.length > 12
                            ? `${fileName.slice(0, 12)}...`
                            : fileName}
                        </p>
                      ) : null}
                    </div>
                  );
                }}
              />
            </div>

            <div className="grid grid-cols-[1fr_auto] gap-2 items-start">
              <NewinputField
                name="contractDate"
                type="date"
                title="Start Contract Date"
                placeholder=""
                className="w-full"
                register={register}
                error={errors?.contractDate}
                validation={{
                  required: !merchantData ? "Contract date is required" : false,
                }}
                disabled={!!merchantData}
                min={new Date().toISOString().split("T")[0]}
              />
              <Controller
                control={control}
                name="contractDocument"
                rules={{
                  required: !merchantData ? "File is required" : false,
                  validate: (file: File) => {
                    if (merchantData) return true;
                    if (!file) return "Please select a file";
                    if (file?.size > 1 * 1024 * 1024)
                      return "File size must be 1 MB or less";
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                    ];
                    if (
                      file.type
                        ? !allowedTypes.includes(file.type)
                        : !["jpeg", "png", "jpg"].includes(
                            getFileExtension(file as any),
                          )
                    ) {
                      return "Only JPG, JPEG, or PNG allowed";
                    }
                    return true;
                  },
                }}
                render={({ field, fieldState }) => {
                  const fileName =
                    field.value instanceof File
                      ? field.value.name
                      : typeof field.value === "string" && field.value
                        ? decodeURIComponent(field.value.split("/").pop() || "")
                        : "";

                  return (
                    <div className="flex flex-col gap-1">
                      <p className="text-sm text-transparent select-none">u</p>
                      <input
                        type="file"
                        id="contract-doc"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              contractDocument: true,
                            }));
                            clearErrors("contractDocument");
                          }
                        }}
                      />
                      <label
                        htmlFor="contract-doc"
                        className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                      >
                        <IconCloudUpload stroke={1} size={20} />
                      </label>
                      {fieldState.error ? (
                        <p className="text-red-500 text-xs leading-tight">
                          {fieldState.error.message}
                        </p>
                      ) : fileName ? (
                        <p
                          className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                          title={fileName}
                        >
                          ✓ Uploaded File{" "}
                          {fileName.length > 12
                            ? `${fileName.slice(0, 12)}...`
                            : fileName}
                        </p>
                      ) : null}
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
        {isNippco && (
          <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <SectionHeader icon={IconUser} title="Coverage Radius" />
            <NewinputField
              name="radius"
              type="text"
              title="Radius (km)"
              placeholder="Enter Radius"
              className="col-span-2"
              register={register}
              error={errors?.radius}
              validation={{
                required: isNippco ? "Radius is required" : false,
                pattern: {
                  value: /^\d*\.?\d*$/,
                  message: "Invalid radius",
                },
              }}
              other={{
                inputMode: "decimal",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  setValue("radius", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AddMerchantModal;
